export default __webpack_public_path__ + "43349ebdfb35e7bbd551a470f8fa4b95.png";